import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const sections = [
  { id: 'overview', label: 'Overview', icon: 'FileText' },
  { id: 'data-collected', label: 'Data We Collect', icon: 'Database' },
  { id: 'how-we-use', label: 'How We Use Data', icon: 'Settings' },
  { id: 'data-retention', label: 'Data Retention', icon: 'Clock' },
  { id: 'third-party', label: 'Third-Party Services', icon: 'Link' },
  { id: 'user-rights', label: 'Your Rights', icon: 'UserCheck' },
  { id: 'cookies', label: 'Cookies & Tracking', icon: 'Cookie' },
  { id: 'security', label: 'Security', icon: 'Shield' },
  { id: 'contact', label: 'Contact Us', icon: 'Mail' },
];

const PolicySidebar = ({ activeSection, onSectionClick }) => {
  return (
    <div className="sticky top-24 space-y-1">
      <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wider mb-3 px-3">
        Contents
      </p>
      {sections?.map((section) => (
        <motion.button
          key={section?.id}
          onClick={() => onSectionClick?.(section?.id)}
          whileHover={{ x: 2 }}
          transition={{ duration: 0.15 }}
          className={`w-full flex items-center space-x-3 px-3 py-2.5 rounded-lg text-left transition-all duration-200 ${
            activeSection === section?.id
              ? 'bg-primary/10 text-primary font-medium' :'text-muted-foreground hover:text-foreground hover:bg-muted/50'
          }`}
        >
          <Icon
            name={section?.icon}
            size={15}
            className={activeSection === section?.id ? 'text-primary' : 'text-muted-foreground'}
          />
          <span className="text-sm">{section?.label}</span>
          {activeSection === section?.id && (
            <motion.div
              layoutId="activeIndicator"
              className="ml-auto w-1.5 h-1.5 rounded-full bg-primary"
            />
          )}
        </motion.button>
      ))}
    </div>
  );
};

export default PolicySidebar;
